/* eslint-env browser */ "use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var mainBlock = document.createElement("div");
    mainBlock.classList.add("notification", type);
    // document.body.append(mainBlock);
    var titleNotification = document.createElement("h2");
    titleNotification.className = "title";
    titleNotification.textContent = title;
    mainBlock.append(titleNotification);
    var descriptionNotification = document.createElement("p");
    descriptionNotification.textContent = description;
    mainBlock.append(descriptionNotification);
    mainBlock.style.position = "absolute";
    mainBlock.style.top = posTop + "px";
    mainBlock.style.right = posRight + "px";
    document.body.append(mainBlock);
    setTimeout(function() {
        mainBlock.style.visibility = "hidden";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.04c45cac.js.map
